import React from "react";
import { useHistory } from 'react-router-dom'
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Translate } from "../../../../language";
import Button from "../../../../utils/components/Button/Button";
import { SubWineryIcon } from "../../../../assets/icons";
import TitleSVG from "../../../../utils/components/TitleSVG/TitleSVG";
import Input from "../../../../utils/components/Input/Input";
import style from "./SubWinery.module.css"


const validationSchema = Yup.object().shape({
  NSwinery: Yup.string().required("El nombre es requerido"),
  CSwinery: Yup.string().required("La ciudad es requerida"),
  DSwinery: Yup.string().required("El departamento es requerido"),
});

export default function CreateSubWinery({ setData, idWarehouse }) {
  const history = useHistory();

  return (
    <>
      <TitleSVG Icon={SubWineryIcon} titleHighlight={Translate('create', 'es')} title={Translate('subWinery', 'es')} />

      <Formik
        initialValues={{
          NSwinery: "",
          CSwinery: "",
          DSwinery: "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          setData(values)
          history.push(`/Admin/Inventory/ProductListById/${idWarehouse}`);

        }}
      >
        {(props) => (

          <Form className={`${style.form_container}`}>

            <div className={`${style.input_container}`}>
              <label className={`${style.input_label}`}>Nombre de Sub-Bodega: </label>
              <Input
                className={`${style.input_form}`}
                type="text" name="NSwinery"
                placeholder="Nombre de Sub-Bodega"
                onChange={props.handleChange}
                value={props.values.NSwinery}
              />
              <br />
              <ErrorMessage name="NSwinery" component="div" />
            </div>
            <div className={`${style.input_container}`}>
              <label className={`${style.input_label}`}>Ciudad: </label>
              <Input
                className={`${style.input_form}`}
                type="text" name="CSwinery"
                placeholder="Ciudad"
                onChange={props.handleChange}
                value={props.values.CSwinery} />
              <br />
              <ErrorMessage name="CSwinery" component="div" />
            </div>
            <div className={`${style.input_container}`}>
              <label className={`${style.input_label}`}>Departamento: </label>
              <Input
                className={`${style.input_form}`}
                type="text" name="DSwinery"
                placeholder="Departamento"
                onChange={props.handleChange}
                value={props.values.DSwinery}
              />
              <br />
              <ErrorMessage name="DSwinery" component="div" />
            </div>
            <Button classNameContent={"button-save-verify-account"} type="submit" text={Translate('create', 'es')} />

          </Form>
        )}
      </Formik>
    </>
  );
}